(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-find-model"] && !Shopify.designMode) return;
  try {
    
  /*
    <pfm-model-guide>
    Convierte la navegación por anclas en pestañas accesibles (patrón ARIA
    tabs, flechas/Inicio/Fin). Sin JS todo sigue visible y enlazado.
    · Paneles inactivos con hidden="until-found": siguen en el HTML y el
      buscador del navegador (Ctrl+F) los abre solos (evento beforematch).
    · El hash (#lavadora) abre la pestaña: enlaces compartibles y citables.
    · En el editor de temas, seleccionar un bloque abre su panel.
    Sin dependencias ni variables globales; seguro con varias instancias.
  */
  (function () {
    if (!window.customElements || customElements.get('pfm-model-guide')) return;

    class PfmModelGuide extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';

        this.tabs = Array.prototype.slice.call(this.querySelectorAll('[data-pfm-tab]'));
        this.panels = this.tabs.map(function (tab) {
          return document.getElementById(tab.getAttribute('href').slice(1));
        });
        if (this.tabs.length < 2 || this.panels.indexOf(null) !== -1) return;

        var list = this.querySelector('[data-pfm-tablist]');
        list.setAttribute('role', 'tablist');
        Array.prototype.forEach.call(list.children, function (li) { li.setAttribute('role', 'presentation'); });

        var self = this;
        this.tabs.forEach(function (tab, i) {
          var panel = self.panels[i];
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', panel.id);
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', tab.id);
          tab.addEventListener('click', function (e) { e.preventDefault(); self.select(i, true); });
          tab.addEventListener('keydown', function (e) { self.onKey(e, i); });
          panel.addEventListener('beforematch', function () { self.select(i, false); });
        });

        this.onEditorSelect = function (e) {
          var i = self.panels.indexOf(e.target);
          if (i > -1) self.select(i, false);
        };
        document.addEventListener('shopify:block:select', this.onEditorSelect);

        var fromHash = this.indexFromHash();
        this.select(fromHash > -1 ? fromHash : 0, false);
        this.classList.add('is-enhanced');
        if (fromHash > -1) this.scrollIntoView({ block: 'start' });
      }

      disconnectedCallback() {
        if (this.onEditorSelect) document.removeEventListener('shopify:block:select', this.onEditorSelect);
      }

      indexFromHash() {
        var hash = decodeURIComponent(window.location.hash.slice(1));
        if (!hash) return -1;
        return this.panels.findIndex(function (p) { return p.id === hash; });
      }

      select(index, updateHash) {
        var self = this;
        this.tabs.forEach(function (tab, i) {
          var on = i === index;
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.tabIndex = on ? 0 : -1;
          if (on) self.panels[i].removeAttribute('hidden');
          else self.panels[i].setAttribute('hidden', 'until-found');
        });
        if (updateHash && window.history && history.replaceState) {
          history.replaceState(null, '', '#' + this.panels[index].id);
        }
      }

      onKey(e, i) {
        var last = this.tabs.length - 1;
        var next = null;
        if (e.key === 'ArrowRight') next = i === last ? 0 : i + 1;
        else if (e.key === 'ArrowLeft') next = i === 0 ? last : i - 1;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = last;
        if (next === null) return;
        e.preventDefault();
        this.select(next, true);
        this.tabs[next].focus();
        this.tabs[next].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    }

    customElements.define('pfm-model-guide', PfmModelGuide);
  })();

  } catch(e) { console.error(e); }
})();
})();
